import {BadgeSize, BadgeType, BadgeVariant} from './types'

// todo: maybe remove "simple", b/c no simple badge in "new" new design

export const getColor = (
  type: BadgeType,
  variant: BadgeVariant,
  unread: boolean
): string => {
  if (variant === 'panel') {
    return 'text-panel-text-secondary'
  }
  switch (type) {
    case 'rounded':
    case 'packed':
      return unread ? 'text-invert' : 'text-secondary'
    case 'simple':
      return unread ? 'text-notification-primary' : 'text-secondary'
  }
}

export const getBackgroundColor = (
  type: BadgeType,
  variant: BadgeVariant,
  unread?: boolean
): string => {
  if (variant === 'panel') {
    return 'bg-panel-background-badge'
  }
  switch (type) {
    case 'rounded':
    case 'packed':
      return unread ? 'bg-notification-primary' : 'bg-tertiary'
    case 'simple':
      return 'bg-transparent'
  }
}

export const getBorderRadius = (type: BadgeType, size: BadgeSize): string => {
  if (type === 'rounded') {
    return 'rounded-full'
  }

  switch (size) {
    case 16:
    case 20:
    case 24:
    case 32:
      return 'rounded-3'
  }
}

export const getSize = (size: BadgeSize): string => {
  switch (size) {
    case 16:
      return 'h-16 min-w-16'
    case 20:
      return 'h-20 min-w-20'
    case 24:
      return 'h-24 min-w-24'
    case 32:
      return 'h-32 min-w-32'
  }
}
